import React, { useMemo } from "react";
import { SelectInput, maxValue, minValue, required } from "react-admin";

import { get } from "lodash";
import { useFormState } from "react-final-form";

const MonthInput = ({ ...props }) => {
  const formState = useFormState();
  const minMonth = useMemo(
    () =>
      props.source === "from_month" ? 1 : get(formState.values, "from_month"),
    [formState.values, props.source]
  );
  const choices = useMemo(
    () =>
      Array.from(Array(18).keys())
        .filter((m) => m + 1 >= minMonth)
        .map((month) => ({
          id: month + 1,
          name: month + 1,
        })),
    [minMonth]
  );
  return (
    <SelectInput
      {...props}
      validate={[required(), minValue(minMonth), maxValue(18)]}
      choices={choices}
    />
  );
};
export default MonthInput;
